import { organisationPrimaryLabel } from "./organisationUtils";

/**
 * Read-only organisation field — shows name (e.g. R001), not UUID.
 * The UUID stays in form state / API payloads only.
 */
export default function OrganisationDisplayField({
  organisationId = "",
  organisationName = "",
  label = "Organisation",
  hint = "Your account is linked to this organisation.",
  className = "",
}) {
  const display = organisationPrimaryLabel(organisationName, organisationId);

  return (
    <div className={className}>
      <label className="block text-sm text-gray-600 mb-2">{label}</label>
      <div
        className="w-full rounded-md border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm font-medium text-slate-900"
        aria-readonly="true"
      >
        {display || "—"}
      </div>
      {hint ? <p className="mt-1 text-xs text-slate-500">{hint}</p> : null}
    </div>
  );
}
